import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Authentication Module
import Account from "./auth/register/reducer";
import Login from "./auth/login/reducer";
import Forget from "./auth/forgetpwd/reducer";
import Users from "./CompanySettings/users/reducer";
import Profile from "./CompanySettings/Profiles/reducer";

//Vendor Quotation
import VendorQuotation from "./VendorQuotation/reducer";
import VendorPO from "./VendorPO/reducer";

import menu from "./menu/reducer";

import Mini from "./Mini/reducer";

import userProfile from "./UserProfile/reducer";

import Menus from "./Masters/Menus/reducer";
import MenuItems from "./Masters/MenuItems/reducer";
import MastersMenu from "./Masters/MastersMenu/reducer";
import Location from "./Masters/Locations/reducer";
import quality from "./Masters/quality/reducer";
import SubLocation from "./Masters/SubLocations/reducer";
import orderLocations from "./Masters/OrderLocations/reducer";
import Department from "./Masters/Departments/reducer";
import ProductGroup from "./Masters/ProductGroups/reducer";
import Product from "./Masters/Products/reducer";
import Vendor from "./Masters/Vendors/reducer";
import Category from "./Masters/Category/reducer";
import Section from "./Masters/Section/reducer";
import BasicUnit from "./Masters/BasicUnit/reducer";
import Tax from "./Masters/Taxs/reducer";
import PrefixCode from "./Masters/PrefixCode/reducer";

import Materialrequest from "./MaterialRequest/reducer";
import Servicerequest from "./ServiceRequest/reducer";
import PurchaseIndent from "./PurchaseIndent/reducer";
import SRpurchaseIndent from "./SRPurchaseIndent/reducer";
import RequestForQuotation from "./RequetForQuotation/reducer";
import SRRequestForQuotation from "./SRRequetForQuotation/reducer";
import Quotation from "./Quotation/reducer";
import SRQuotation from "./SRQuotation/reducer";
import CompareQuotation from "./CompareQuotation/reducer";
import SRCompareQuotation from "./SRCompareQuotation/reducer";
import PurchaseOrder from "./PurchaseOrder/reducer";
import SRPurchaseOrder from "./SRPurchaseOrder/reducer";
import ingatepass from "./ingatepass/reducer";
import Dashboard from "./Dashboard/reducer";
import Notification from "./Notification/reducer";
import System from "./System/reducer";

import reports from "./Reports/reducer";

import AuditReport from "./Audit_Report/reducer";

const rootReducer = combineReducers({
	// public
	Layout,

	// Authentication
	Account,
	Login,
	Forget,
	//Users & Profile
	Users,
	Profile,
	//VendorQuotation
	VendorQuotation,
	VendorPO,

	//menu
	menu,

	//Mini
	Mini,
	//userProfile
	userProfile,
	//Masters
	Menus,
	MenuItems,
	MastersMenu,
	Location,
	quality,
	SubLocation,
	orderLocations,
	Department,
	ProductGroup,
	Product,
	Vendor,
	Category,
	Section,
	BasicUnit,
	Tax,
	PrefixCode,
	Materialrequest,
	Servicerequest,
	PurchaseIndent,
	SRpurchaseIndent,
	RequestForQuotation,
	SRRequestForQuotation,
	Quotation,
	SRQuotation,
	CompareQuotation,
	SRCompareQuotation,
	PurchaseOrder,
	SRPurchaseOrder,
	ingatepass,
	reports,
	Dashboard,
	Notification,
	System,

	AuditReport,
});

export default rootReducer;
